import {
  Comparison,
  GetParentObject,
  QuestionNamesById,
  QuestionThreadParent,
  QuestionThreadParentBase,
  TriggerValue,
} from '@components/dynamic-form/types';

export const nonPcnQuestionNameByIdV2: QuestionNamesById = {
  1: 'nwpPermitTypeID',
  1.2: 'nwpGenInSetRequiringPCN',
  2: 'nwpGenEnforcementAction',
  3: 'nwpGenStateJointPermit',
  4: 'nwpGenSpeciesCrithabRelated',
  4.1: 'nwpGenFedAgencyFulfilledESASec7',
  5: 'nwpGenEffectsHistoricPlaces',
  5.1: 'nwpGenFedAgencyFulfilledNHPASec106',
  6: 'nwpGenActivityInNWSR',
  8: 'nwpGenActivityAlterCivilWorksProject',
  9: 'nwpGenActivityRequireNWPTermWaiver',
  10: 'nwpGenActivityMeetsRegionalConditions',
  10.1: 'nwpGenRegionalConditionsRequirePCN',
  11: 'nwp1AidsToNavigation',
  12: 'nwp2StructInArtificialCanals',
  13: 'nwp3RepairServicableStructFill',
  13.1: 'nwp3MinorDeviationsInStructFillArea',
  13.2: 'nwp3StreamModLimitedForRepairOfStruct',
  14: 'nwp3RemovalAuthStructFill',
  15: 'nwp3RemovSedDebrisWithinStructFill',
  16: 'nwp3RepairDamagedStructFill',
  17: 'nwp3RepairWithin2YrsDamage',
  18: 'nwp3TemporaryStructFillWork',
  18.1: 'nwp3MaintDredgeForNav',
  19: 'nwp4FishWildlifHarvstAttract',
  19.1: 'nwp4ArtificialReefForHoldingSpecies',
  20: 'nwp5ScientificMeasDevicUse',
  21: 'nwp5SciMeasDevicRemoved',
  22: 'nwp5WeirsFlumesConstructed',
  23: 'nwp5WeirFlumeFillLimited',
  24: 'nwp6InvolvesSurveyActivities',
  25: 'nwp6ExplTrenchRestored',
  25.1: 'nwp6RestoredToPreconstElevation',
  26: 'nwp6TrenchBackfillWithSoil',
  27: 'nwp6ConstrTempPad',
  28: 'nwp6TempPadImp1To10Acre',
  29: 'nwp6DischrgFillHistoricResrc',
  30: 'nwp6DischrgFillOilGasExpl',
  31: 'nwp6PlugTestWellsOilGasExpl',
  32: 'nwp6DischrgFillRoads',
  33: 'nwp6PermanentStruct',
  34: 'nwp9StructInAchorageArea',
  35: 'nwp10MooringBuoys',
  36: 'nwp11TempStructRecUse',
  37: 'nwp11StructRemoved30Days',
  38: 'nwp12OilGasPipelineActivities',
  39: 'nwp12ImpactsOver1To10Acre',
  40: 'nwp12ImpactsNavgblWaters',
  41: 'nwp12PipelnConstructImpactsWaters',
  41.1: 'nwp12PipelnActvtyOvr250Mi',
  42: 'nwp12ChngsContoursWotus',
  43: 'nwp12TrenchMaterlSideCast',
  44: 'nwp12SidecastMtrlRmvd3Mo',
  45: 'nwp12TrenchDrainsWotus',
  46: 'nwp12ConstrOilGasSubstation',
  47: 'nwp12DischrgFillSubstation',
  48: 'nwp12ConstrFndtnAboveGrnd',
  49: 'nwp12ConstrAccessRoad',
  50: 'nwp12DischrgFillAccessRoad',
  51: 'nwp12RemediateDrillingFluids',
  52: 'nwp12TempStructFillWork',
  53: 'nwp13ErosionControlPrevent',
  54: 'nwp13MaterlExceedsErosnProt',
  55: 'nwp13ActvtyMoreThan500Lf',
  56: 'nwp13ActvtyExceeds1CyFoot',
  57: 'nwp13DischrgFillSpecialAqSite',
  58: 'nwp13MatrlImpairSurfacWaterFlow',
  59: 'nwp13MatrlErodedByNormalFlow',
  60: 'nwp13NativePlantsUsed',
  61: 'nwp13StreamChannelization',
  62: 'nwp13TempStructFillWork',
  63: 'nwp14InvolvesWaterCrossings',
  64: 'nwp14ImpactsOver1To10Acre',
  65: 'nwp14DischrgFillSpecialAqSite',
  65.1: 'nwp14StreamModInProjVicinity',
  65.2: 'nwp14StreamModMinimumAmount',
  66: 'nwp14TempStructFillWork',
  67: 'nwp14ConstructNonlinearFeat',
  68: 'nwp15DischrgFill4BridgeConstr',
  69: 'nwp15FillForCauseway',
  70: 'nwp16RetrnWatrUplndDspArea',
  71: 'nwp18MinorDischargesAll',
  72: 'nwp18DischrgFillExceed10Cy',
  72.1: 'nwp18DischargeCauseLossOver1To10Acre',
  72.2: 'nwp18StreamDiversion',
  73: 'nwp18DischrgFillSpecialAqSite',
  74: 'nwp19DredgeNoMore25CyBelow',
  74.1: 'nwp19DredgeThroughAquaticVegetation',
  74.2: 'nwp19DredgedMaterialDepositedOutsideWaters',
  75: 'nwp20ResponseOperationsOil',
  75.1: 'nwp20ActivityToCleanupOilReleasesRequired',
  75.2: 'nwp20TempStructUseForSpillTraining',
  76: 'nwp22RemovalOfVessels',
  77: 'nwp22VesselHistoricPlace',
  78: 'nwp22DischrgFillSpecialAqSite',
  79: 'nwp23ApprovedCategExcl',
  80: 'nwp23CoveredRegGuideLtr',
  81: 'nwp24StateTribeAdminS404',
  82: 'nwp25StructuralDischarged',
  82.1: 'nwp25FilledStructMembersToSupportStructs',
  82.2: 'nwp25Sec10WatersWork',
  83: 'nwp28ModsExistingMarinas',
  83.1: 'nwp28DredgingOrMarinaExpansion',
  84: 'nwp30MoistSoilMgmtWildlife',
  84.1: 'nwp30RiparianAreasMaintained',
  84.2: 'nwp30Sec10WatersWork',
  85: 'nwp30ConstrFeaturesSoilMgmt',
  86: 'nwp30ConvertWetlands',
  87: 'nwp33TempConstrAuthorized',
  88: 'nwp33TempConstrNotSubject',
  89: 'nwp33MeasuresMaintainFlows',
  90: 'nwp33MatrlNotErodedHighFlow',
  91: 'nwp33TempFillEntirelyRemoved',
  91.1: 'nwp33DewaterWetlandsOrOtherAqSites',
  92: 'nwp33InNavgblWaters',
  93: 'nwp35MainDredgExistBasins',
  93.1: 'nwp35DredgedMaterialDepositedOutsideWaters',
  94: 'nwp36ConstrRepairBoatRamps',
  95: 'nwp36DischrgFillLess50Cy',
  96: 'nwp36RampLess20FtWidth',
  97: 'nwp36BaseCrushedStone',
  98: 'nwp36ExcavLimitedRemoved',
  99: 'nwp36FillSpecialAqSite',
  99.1: 'nwp36DredgeInSec10Waters',
  100: 'nwp41ReshapeExistDitches',
  100.1: 'nwp41IncreasedDrainageCapBeyondOriginal',
  100.2: 'nwp41RelocationOfDrainageDitchesInWaters',
  101: 'nwp43StormWtrMgmtFacilities1',
  102: 'nwp43StormWtrMgmtFacilities2',
  102.1: 'nwp43RestoreStormWtrMgmtFacilities',
  102.2: 'nwp43DischargesIntoNonTidalWetlands',
  103: 'nwp48CommShellfshMaricltrAct',
  104: 'nwp48ImpHalfAcreSubMrgVeg',
  104.1: 'nwp48ImpHalfAcreSubMrgVegNotForCommercialActvtyPast100Yrs',
  105: 'nwp48CultNonIndigenousSpecies',
  106: 'nwp48CultNuisanceSpecies',
  107: 'nwp48AttendantFeatures',
  108: 'nwp51LandBasedRenewableEnergy',
  108.1: 'nwp51OnlyConstructMaintRepairElectricUtilityLines',
  108.2: 'nwp51DischargeIntoNonTidalWetlands',
  109: 'nwp51LossMore1To10Acre',
  110: 'nwp57ElecUtilTelecomActvty',
  111: 'nwp57ImpactsOver1To10Acre',
  112: 'nwp57ImpactsNavgblWaters',
  113: 'nwp57TrenchMaterlSidecast',
  114: 'nwp57SidecastMtrlRmvd3Mo',
  115: 'nwp57TrenchDrainsWotus',
  115.1: 'nwp57UtilLineChangesContoursOfWaters',
  116: 'nwp57ConstrElecUtilTelecom',
  116.1: 'nwp57SubstationDischargeIntoNonTidalWetlands',
  117: 'nwp57FoundationsForOverhead',
  118: 'nwp57ConstructAccessRoads',
  119: 'nwp57DischrgFillForRoads',
  120: 'nwp57TempWorkForElecUtil',
  121: 'nwp58UtilLineActWaterOther',
  122: 'nwp58ImpactsOver1To10Acre',
  123: 'nwp58ImpactsNavgblWaters',
  124: 'nwp58TrenchMaterlSidecast',
  125: 'nwp58SidecastMtrlRmvd3Mo',
  126: 'nwp58TrenchDrainsWotus',
  126.1: 'nwp58UtilLineChangesContoursOfWaters',
  127: 'nwp58ConstrUtilSubstation',
  127.1: 'nwp58SubstationDischargesIntoNonTidalWetlands',
  128: 'nwp58FoundationsAboveGround',
  129: 'nwp58ConstructAccessRoads',
  130: 'nwp58DischrgFillForRoads',
  131: 'nwp58TempWorkForUtilLine',
  132: 'nwp60DischargesForRestoringAqLifeMobility',
  132.1: 'nwp60DamRemovalActivities',
  132.2: 'nwp60DischargesCauseLossOfWatersOver1Acre',
  132.3: 'nwp60CauseLossOver1To10Acre',
  132.4: 'nwp60NewCulvertsAtCrossings',
  133: 'nwpGcMoreAdverseNavEffect',
  134: 'nwpGcDisruptLifecycleMvmtAqLife',
  135: 'nwpGcTempCrossSustainMvmt',
  136: 'nwpGcDestructSpawnArea',
  137: 'nwpGcAvoidBreedWaterArea',
  138: 'nwpGcShellfshConcentrArea',
  139: 'nwpGcShellfshHarvestActvty',
  140: 'nwpGcUnsuitableMaterial',
  141: 'nwpGcPubWaterSupplyIntake',
  142: 'nwpGcRepairImprovWaterIntake',
  143: 'nwpGcImpoundWaterEffectMinimized',
  144: 'nwpGcPreconstrWaterflowsMaintaind',
  145: 'nwpGcPurposeImpoundManageFlow',
  146: 'nwpGcAlterBenefitAqEnviron',
  147: 'nwpGcComplyFemaRequirements',
  148: 'nwpGcMeasuresMinimizeSoilDisturb',
  149: 'nwpGcSoilErosionControls',
  150: 'nwpGcPermStableEarliestDate',
  151: 'nwpGcTempStructRemovedAfterUse',
  152: 'nwpGcProperMaintenance',
  153: 'nwpGcLinearProjTransport',
  154: 'nwpGcLinearProjCrossings',
  155: 'nwpGcNonLinearProjRepresented',
  156: 'nwpGcIndependentUtility',
  157: 'nwpGcTotalImpactUnderThreshold',
  158: 'nwpGcImpairTribeRights',
  159: 'nwpGcMbtaBgepaCompliance',
  160: 'nwpGcDiscoveryNotifyConstruction',
  161: 'nwpGcCriticalResourceWater',
  162: 'nwpGcCoveredNwpListNeedsPreApp',
  163: 'nwpGcCoveredNwpListNeedsPcn',
  164: 'nwpGcAvoidAdverseEffects',
  165: 'nwpGcImpoundStructCompliance',
  166: 'nwpGc401WqcIssued',
  167: 'nwpGc401WqcCompliance',
  168: 'nwpGcCzmaLocated',
  169: 'nwpGcFedApplicantOrWorkOnTribalLands',
  170: 'nwpGcCzmaIssued',
  170.2: 'nwpGcCzmaCompliance',
  171: 'nwpGcMultipleNwpAuthorize',
  172: 'nwpGcImpactsBelowAcreageLimit',
  173: 'nwpGcMultipleNwpImpactsAcreLimit',
};

export const pcnRequiredValues = [
  '7',
  '8',
  '8',
  '17',
  '21',
  '27',
  '29',
  '31',
  '34',
  '37',
  '38',
  '39',
  '40',
  '42',
  '44',
  '45',
  '46',
  '49',
  '50',
  '52',
  '53',
  '54',
  '55',
  '59',
];

export const nonPcnQuestionIdByNameV2 = Object.fromEntries(
  Object.entries(nonPcnQuestionNameByIdV2).map(([key, value]) => [value, parseFloat(key)])
);

export const getParentObjectV2: GetParentObject = (
  parentId: number,
  parentTypeId: number,
  comparison: Comparison,
  triggerValue: TriggerValue,
  requiredQuestions?: QuestionThreadParentBase[]
): QuestionThreadParent => {
  const parentName = nonPcnQuestionNameByIdV2[parentId as keyof typeof nonPcnQuestionNameByIdV2] as string;

  const parent: QuestionThreadParent = {
    parentId,
    parentName,
    comparison,
    triggerValue,
    parentTypeId,
    requiredQuestions: requiredQuestions && requiredQuestions.length > 0 ? requiredQuestions : [],
  };

  return parent;
};
